/**
 * @param {Array<{ distanceMiles?: number, searchContainers?: string[] }>} cards
 * @param {number} distanceLimitMi max miles (cards with larger distanceMiles are excluded)
 * @param {string} containerSearch case-insensitive substring match on searchContainers
 */
export function filterPlannerPool(cards, distanceLimitMi, containerSearch) {
  const q = String(containerSearch || '').trim().toLowerCase();
  const limit = Number(distanceLimitMi);
  const lim = Number.isFinite(limit) ? limit : 1000;

  return cards.filter((card) => {
    const d = Number(card.distanceMiles);
    if (Number.isFinite(d) && d > lim) return false;
    if (!q) return true;
    const ids = Array.isArray(card.searchContainers) ? card.searchContainers : [];
    return ids.some((id) => String(id).toLowerCase().includes(q));
  });
}
